import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../styles/Building MGMT/BuildingHeader.module.css';

const BuildingHeader = ({ building, onEdit }) => {
  return (
    <div className={styles.headerContainer}>
      <div className={styles.topRow}>
        <Link to="/landlord/properties" className={styles.backLink}>
          ← Back to Properties
        </Link>
        <div className={styles.actionButtons}>
          <button className={styles.editButton} onClick={onEdit}>Edit Building</button>
          <button className={styles.viewButton}>View as Tenant</button>
        </div>
      </div>

      <h1 className={styles.buildingName}>{building.name}</h1>
    </div>
  );
};

export default BuildingHeader;
